import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import dairyLinkLogo from '../../Assets/Images/DairyLink-logo.svg';

const resetBrandTheme = () => {
  document.documentElement.style.setProperty('--brand-color', '#0f3d9a');
  document.documentElement.style.setProperty('--brand-secondary-color', '#4f6bd7');
  document.documentElement.style.setProperty('--brand-active-text-color', '#14223a');
  document.documentElement.style.setProperty('--secondary-color', '#4f6bd7');
  document.documentElement.style.setProperty('--active-text-color', '#14223a');
};

const Dashboard = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('udsAdminToken');
    localStorage.removeItem('instance_settings');
    navigate('/dashboard/login');
    window.location.reload();
  };

  React.useEffect(() => {
    resetBrandTheme();
    const token = localStorage.getItem('udsAdminToken');
    if (!token) {
      navigate('/dashboard/login');
    }
  }, [navigate]);

  const isActive = (path) => location.pathname === path;

  return (
    <div className="dashboard-layout">
      <header className="dashboard-header">
        <div className="dashboard-header__top">
          <Link to="/dashboard/instances" className="brand" style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className="brand-badge">
              <img src={dairyLinkLogo} alt="DairyLink" width={38} height={38} />
            </div>
            <div>
              <h1 className="brand-title">Admin Hub</h1>
              <p className="brand-subtitle">Manage tenant experiences, instances & users</p>
            </div>
          </Link>

          <div className="dashboard-header__actions">
            <div className="user-chip">
              <span>Signed in</span>
              <strong>Admin</strong>
            </div>
            <button onClick={handleLogout} className="button ghost sm">
              Sign out
            </button>
          </div>
        </div>

        <nav className="dashboard-nav">
          <Link
            to="/dashboard/instances"
            className={`dashboard-nav__item ${isActive('/dashboard/instances') ? 'active' : ''}`}
          >
            <i className="uicon-instances" />
            <span>Instances</span>
          </Link>
          <Link
            to="/dashboard/users"
            className={`dashboard-nav__item ${isActive('/dashboard/users') ? 'active' : ''}`}
          >
            <i className="uicon-users" />
            <span>Admin Users</span>
          </Link>
        </nav>
      </header>

      <main className="dashboard-main">{children}</main>
    </div>
  );
};

export default Dashboard;